// @flow
import type { NewsletterNotifications, SearchNotification } from '../types';

export function disableAllNewsletterNotifications(
  notifications: NewsletterNotifications
): NewsletterNotifications {
  return {
    trovitNewsletters: {
      ...notifications.trovitNewsletters,
      active: false,
    },
    partnersNewsletters: {
      ...notifications.partnersNewsletters,
      active: false,
    },
  };
}

export function disableAllSearchNotifications(
  notifications: Array<SearchNotification<*>>
): Array<SearchNotification<*>> {
  return notifications.map(notification => ({
    ...notification,
    active: false,
  }));
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/DisableNotifications/utils.js